import Axios from 'axios'

export default {
    state: {
        notifications: [],
        localNotifications: [],
    },
    getters: {
        localNotifications(state, rootGetters) {
            if (rootGetters.user) {
                if (!rootGetters.user.fullName) // name condition
                    state.localNotifications.push({
                        text: rootGetters.user.type != 'user' ?
                            '<strong>Important !</strong> Vous devez ajouter votre nom.<p style="font-size: x-small; color="gray";">pour être apparu dans la recherche</p>'
                            : 'Il est mieux d\'ajouter votre nom.',
                        to: '/profile'
                    });
                if (!rootGetters.user.photoUrl) // photo condition
                    state.localNotifications.push({
                        text: rootGetters.user.type != 'user' ?
                            '<strong>Important !</strong> Vous devez ajouter votre photo'
                            : 'Il est mieux d\'ajouter votre photo.',
                        to: '/profile'
                    });
                if (!rootGetters.user.description && rootGetters.user.type != 'user')//description condition
                    state.localNotifications.push({
                        text: 'Ajouter une description de vous est appréciable pour les utilisateurs en que ' + rootGetters.user.type,
                        to: '/profile'
                    });
                if (!rootGetters.user.birthday && rootGetters.user.type != 'gym')// birthday condition
                {
                    state.localNotifications.push({
                        text: 'Il est mieux d\'ajouter votre date de naissance',
                        to: '/profile'
                    });
                }
                if (rootGetters.user == 'coach')
                    if (rootGetters.user.coach.experience.length == 0)//coach experience condition
                        state.localNotifications.push({
                            text: 'vos expériences précédentes peut convaindre vos potentiels clients de vous contacter.',
                            to: '/profile'
                        });
            }
            return state.localNotifications
        },
        notifications(state) {
            return state.notifications
        }
    },
    mutations: {
        setNotifications(state, payload) {
            state.sideNav = payload;
        },
        pushNotification(state, payload) {
            state.notifications = payload;
        }
    },
    actions: {
        getNotifications({ commit, getters }) {
            let notifications = []
            if (!getters.user.name)
                notifications.push('Vous devez ajouter votre nom')
            if (!getters.user.birthday)
                notifications.push('Vous devez ajouter votre datte de naissance')
            notifications.push(getters.user.birthday)
            commit('setNotifications', notifications)
        },
        async loadNotifications({ commit, getters }) {
            commit('setLoading')
            await Axios.get(`${process.env.VUE_APP_API_URL_NOTIFICATION}${getters.user._id}`)
                .then(res => {
                    console.log('res notifications', res.data)
                    commit('setLoading')
                    if (res.data.success) {
                        let notifications = []
                        res.data.data.forEach(element => {
                            const condition = (element) => element.readerId == getters.user._id;
                            notifications.push({
                                text: element.message,
                                to: element.action,
                                isRead: element.read_by.some(condition),
                                id: element._id,
                                date: element.createdAt,
                                extraData: element.extraData
                            });
                        });
                        notifications = notifications.sort((a, b) => {
                            var keyA = new Date(a.date),
                                keyB = new Date(b.date);
                            // Compare the 2 dates
                            if (keyA < keyB) return 1;
                            if (keyA > keyB) return -1;
                            return 0;
                        });
                        commit('pushNotification', notifications)
                    } else throw new Error(res.data);
                })
                .catch(error => {
                    commit('clearError')
                    commit('setError', error)
                    commit('setSnackAlert', {
                        status: true,
                        success: false,
                        error: true,
                        message: 'Erreur de connexion avec le serveur. réssayer plus tard.'
                    });
                })
        },
        async readNotification({ commit, getters }, payload) {
            commit('setLoading')
            await Axios.put(`${process.env.VUE_APP_API_URL_NOTIFICATION}${payload}`, { user: getters.user._id })
                .then(res => {
                    commit('setLoading')
                    if (res.data.success) {
                    } else throw new Error(res.data);
                })
                .catch(error => {
                    console.log(error.message)
                    commit('clearError')
                    commit('setError', error)
                    commit('setSnackAlert', {
                        status: true,
                        success: false,
                        error: true,
                        message: 'Erreur de connexion avec le serveur. réssayer plus tard.'
                    });
                })
        }
    }
}
